<template>
  <v-sheet class="text-start" v-if="user">
    <page-head
      :title="user.email"
      sub-head="teams"
      :breadcrumb="['Shop', 'Teams', user.email]"
    >
    </page-head>
    <v-tabs v-model="tab" color="red-darken-4">
      <v-tab value="detail">Detail</v-tab>
      <v-tab value="role">Role</v-tab>
    </v-tabs>
    <v-card-text>
      <v-tabs-window v-model="tab">
        <v-tabs-window-item value="detail">
          <v-container fluid>
            <patch-input
              label="Email"
              :default="user.email"
              :readonly="true"
            ></patch-input>
          </v-container>
        </v-tabs-window-item>
        <v-tabs-window-item value="role">
          <v-container fluid>
            <v-checkbox
              v-model="userRoles.admin"
              label="Admin"
              color="primary"
              @update:model-value="updateRole('admin', $event)"
              hide-details
            ></v-checkbox>
            <v-checkbox
              v-model="userRoles.staff"
              label="Staff"
              color="primary"
              @update:model-value="updateRole('staff', $event)"
              hide-details
            ></v-checkbox>
            <v-checkbox
              v-model="userRoles.frontdesk"
              label="Frontdesk"
              color="primary"
              @update:model-value="updateRole('frontdesk', $event)"
              hide-details
            ></v-checkbox>
            <v-checkbox
              v-model="userRoles.updateFund"
              label="Update Fund"
              color="primary"
              @update:model-value="updateRole('update_fund', $event)"
              hide-details
            ></v-checkbox>
          </v-container>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-card-text>
  </v-sheet>
</template>

<script setup>
import PageHead from "@/components/admin_theme/PageHead.vue";
import PatchInput from "@/components/admin_theme/patch/PatchInput.vue";
import { authAxios } from "@/util/Axios";
import { ref, inject } from "vue";
import { useRoute } from "vue-router";

const axios = authAxios();
const route = useRoute();
const cookies = inject("$cookies");
const shopId = cookies.get("toa-rim-shop");

const tab = ref(null);
const user = ref(null);

const userRoles = ref({
  admin: false,
  staff: false,
  frontdesk: false,
  updateFund: false,
});

function updateRole(role, isChecked) {
  console.log(`Update role: ${role} to ${isChecked}`);
  const activeRoles = [];
  if (userRoles.value.admin) activeRoles.push("admin");
  if (userRoles.value.staff) activeRoles.push("staff");
  if (userRoles.value.frontdesk) activeRoles.push("frontdesk");
  if (userRoles.value.updateFund) activeRoles.push("update_fund");

  axios({
    method: "POST",
    url: `${process.env.VUE_APP_BACKEND_URL}/auth/user/id-${route.params.userId}/role`,
    data: {
      shop_id: shopId,
      role: activeRoles,
    },
  });
}

loadUser(route.params.userId).then((response) => {
  user.value = response.data;
  if (user.value.shop_role && user.value.shop_role[shopId]) {
    const roles = user.value.shop_role[shopId];
    userRoles.value.admin = roles.includes("admin");
    userRoles.value.staff = roles.includes("staff");
    userRoles.value.frontdesk = roles.includes("frontdesk");
    userRoles.value.updateFund = roles.includes("update_fund");
  }
});

function loadUser(userId) {
  return axios({
    method: "GET",
    url: `${process.env.VUE_APP_BACKEND_URL}/auth/user/id-${userId}`,
  });
}
</script>
